<template>
    <div class="w-full h-auto relative flex justify-center">
        <div class="w-[95vw] h-[260vw] pt-[42vw] relative">
            <img src="../../assets/img/Desktop/FirestormArena/Vector2.webp" alt="" class="absolute top-[42vw] left-0 w-[85vw]">
            <img src="../../assets/img/Desktop/FirestormArena/Vector2.webp" alt="" class="absolute rotate-[180deg] bottom-0 right-0 w-[85vw]">
            <img src="../../assets/img/Desktop/FirestormArena/8.webp" alt="" class="absolute top-[8.6vw] left-[22.3vw] w-[60vw]">
            <img src="../../assets/img/Desktop/FirestormArena/7.webp" alt="" class="absolute top-[48vw] left-[3vw] w-[88vw]">
            <img src="../../assets/img/Desktop/FirestormArena/9.webp" alt="" class="absolute bottom-[4.5vw] w-[85.75vw] translate-x-[-8vw]">
            <img src="../../assets/img/Desktop/FirestormArena/10.webp" alt="" class="absolute bottom-[46.5vw] right-[0] w-[55.81vw] translate-x-[1vw]">
            <!-- Text -->
             <p class="font-inter font-black text-[7.5vw] text-[#171717] rotate-[90deg] absolute top-[92vw] left-0 translate-x-[-10vw]">Malakor.</p>
              <p class="font-inter font-black text-[7.5vw] text-[#FFF] rotate-[-90deg] absolute bottom-[18vw] right-0 translate-x-[10vw]">Aerthos.</p>
            <div class="absolute w-[100vw] flex flex-col items-center top-[125vw] left-[-4vw] rotate-[-45deg]">
                <p class="text-center text-white font-emeritus text-[14.5vw] leading-[11vw] tracking-[1vw]">
                    Firestorm
                </p>
                <p class="text-center text-white font-emeritus text-[14.5vw] leading-[11vw] tracking-[1vw]">
                    Arena
                </p>
                <p class="font-league text-white text-[3.16vw] text-center font-semibold mt-[2vw]">
                    Immerse yourself in epic battles, where every tactical decision<br/>
                    changes the tide. Watch your heroes showcase their skills and<br/>
                    dominate the battlefield!
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.font-inter {
  font-family: "Inter", sans-serif;
}
</style>